<template>
    <span class="select2 select2-container" ref="select" style="width: 100%" v-click-outside="hide">
        <span class="selection">
            <span class="select2-selection select2-selection--single">
                <input
                    type="text"
                    ref="input"
                    class="form-control"
                    :placeholder="placeholder"
                    :value="modelValue"
                    :disabled="disabled"
                    :tabindex="tabindex"
                    @input="$emit('update:modelValue', $event.target.value)"
                    @keydown.enter="$emit('keydown:enter')"
                    @click="show"
                >
                <span class="select2-selection__arrow" role="presentation">
                    <b role="presentation"></b>
                </span>
            </span>
        </span>
        <span class="dropdown-wrapper" aria-hidden="true"></span>
    </span>

    <Teleport to="body">
        <span
            :class="{
                'select2-container select2-container--default': true,
                'select2-container--open': showed,
            }"
            :style="{
                position: 'absolute',
                top: top,
                left: left
            }"
        >
            <span ref="options" class="select2-dropdown select2-dropdown--above" :style="{width: width, 'min-width': '300px', 'z-index': zIndex}">
                <span class="select2-results">
                    <ul class="select2-results__options" aria-expanded="true" aria-hidden="false" ref="list">
                        <li
                            :class="{
                                'select2-results__option': true,
                                'select2-results__option--highlighted': index === highlightedIndex
                            }"
                            :aria-selected="modelValue === option[optionValue]"
                            v-for="(option, index) in options"
                            :title="option[optionValue]"
                            @mouseover="highlightedIndex = index"
                            @click.stop="$emit('setOptionValue', option[optionKey]), $refs.input.focus()"
                        >
                            {{ option[optionValue] }}
                        </li>
                    </ul>
                </span>
            </span>
        </span>
    </Teleport>
</template>
<script>
import vClickOutside from 'click-outside-vue3'
export default {
    name: "InputSelect",
    props: {
        modelValue: {
            type: [String, Number],
            default: ''
        },
        optionKey: {
            type: String,
            default: "uuid"
        },
        optionValue: {
            type: String,
            default: "name"
        },
        placeholder: {
            type: String,
            default: () => translate('components.select.default_placeholder')
        },
        options: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        },
        tabindex: {
            type: String,
            default: '1'
        }
    },
    emits: ['update:modelValue', 'setOptionValue', 'onShow', 'onHide', 'keydown:enter'],
    data() {
        return {
            showed: false,
            top: 0,
            left: 0,
            width: 0,
            position: 'bottom',
            highlightedIndex: null,
            zIndex: 950
        }
    },
    methods: {
        show() {
            let select = this.$refs.select.getBoundingClientRect(),
                options = this.$refs.options.getBoundingClientRect();

            if (window.innerHeight - select.bottom < options.height + 6) {
                this.position = 'top'
            } else {
                this.position = 'bottom'
            }
            
            addEventListener('keydown', this.handleKeyDown);
            this.$emit('onShow');

            this.calculatePosition();
            this.highlightedIndex = 0
            this.showed = true;
        },
        hide() {
            this.showed = false;
            this.highlightedIndex = null;
            removeEventListener('keydown', this.handleKeyDown)
            this.$emit('onHide');
        },
        scrollIntoViewIfNeeded() {
            const option = this.$refs.list.children[this.highlightedIndex];
            if (option) {
                option.scrollIntoView({
                    block: 'nearest',
                    inline: 'nearest',
                    behavior: 'smooth'
                });
            }
        },
        handleKeyDown(event) {
            if (event.key === 'ArrowUp') {
                this.highlightedIndex = Math.max(this.highlightedIndex - 1, 0);
                event.preventDefault();
                this.scrollIntoViewIfNeeded();
            } else if (event.key === 'ArrowDown') {
                this.highlightedIndex = Math.min(this.highlightedIndex + 1, this.options.length - 1);
                event.preventDefault();
                this.scrollIntoViewIfNeeded();
            } else if (event.key === 'Enter') {
                this.$emit('setOptionValue', this.options[this.highlightedIndex][this.optionKey]);
            }
        },
        calculatePosition() {
            const select = this.$refs.select.getBoundingClientRect(),
                  options = this.$refs.options.getBoundingClientRect();

            if (this.position === 'top') {
                this.top = select.top + window.pageYOffset - options.height - 6 + 'px'
            } else {
                this.top = select.top + window.pageYOffset + select.height + 2 + 'px'
            }

            this.left = select.left + 'px'
            this.width = select.width + 'px'
        },
    },
    mounted() {
        this.calculatePosition()

        let modalCount = document.getElementsByClassName('modal-backdrop').length

        if (modalCount > 0) {
            this.zIndex = 1000 + (modalCount * 10) + 7
        }
    },
    directives: {
        clickOutside: vClickOutside.directive
    }
}
</script>
<style scoped>
.select2-selection--single {
    display: inline;
}
.form-control {
    width: 97%
}
</style>
